import { BOT_TYPE, BotType } from '../constants/botType';

export const SERVER_TYPE_LABELS: Record<BotType, string> = {
    [BOT_TYPE.MAIN_BOT]: 'Main-bot',
    [BOT_TYPE.WL_BOT]: 'WL-bot',
};

export function isMainBot(type: BotType | string): boolean {
    return type === BOT_TYPE.MAIN_BOT || type === 'volume_main';
}

export function isWlBot(type: BotType | string): boolean {
    return type === BOT_TYPE.WL_BOT || type === 'boost_legend';
}

export function getServerTypeLabel(type: BotType | string): string {
    if (isMainBot(type)) return SERVER_TYPE_LABELS[BOT_TYPE.MAIN_BOT];
    if (isWlBot(type)) return SERVER_TYPE_LABELS[BOT_TYPE.WL_BOT];
    return String(type);
}

export function getServerTypeTagColor(type: BotType | string): string {
    return isMainBot(type) ? 'blue' : 'purple';
}
